<script lang="ts">
    export let elements = []
    export let render = (r, i) => r
    export let resolveId = (r, i = null) => r
    export let focusElement = null
    export let selected = null
    import Typography from './Typography.svelte'
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    $: dynamicList = elements.map((e, i) => ({ id: resolveId(e, i), ...e }))
</script>

<ul>
    {#each dynamicList as { id, ...element }, i (id)}
        <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
        <li
            tabindex="0"
            class:active={selected &&
                resolveId(selected, i) === resolveId(element, i)}
            on:keypress={(eventTarget) => {
                dispatch('keypress', { eventTarget })
            }}
            on:click={(eventTarget) => {
                selected = element
                dispatch('click', { eventTarget, element, selected })
            }}
            on:focus={() => (focusElement = element)}
            on:focusout={() => (focusElement = null)}
        >
            {#if $$slots.default}
                <slot {element} {selected} />
            {:else}
                <Typography
                    type="body"
                    style="margin: 0; padding: 0"
                    color="grey-800">{render(element, i)}</Typography
                >
            {/if}
        </li>
    {/each}
</ul>

<style>
    :root {
        --height-row: 47px;
        --bg: var(--color-white);
        --bg-hover: var(--color-grey-050);
    }
    ul {
        width: 100%;
        margin: 0;
        padding: 0;
        height: auto;
        display: flex;
        flex-direction: column;
        list-style: none;
    }
    li {
        width: 100%;
        height: var(--height-row);
        display: flex;
        align-items: center;
        padding-left: 19px;
        list-style: none;
        background: var(--bg);
        transition: all 0.2s ease-in-out;
    }
    li.active,
    li:hover {
        background: var(--bg-hover);
        cursor: pointer;
    }
</style>
